import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';

export function headerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const JWTToken = authService.token;

  if (req.method === 'JSONP') {
    return next(req);
  }

  const requestWithAuthorization = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${JWTToken}`)
  });

  return next(requestWithAuthorization);
}
